import React, { useMemo } from 'react';
import Icon, { ICONS, COLORS } from '../../general-components/icon';
import { ConnectedUser } from '../../../connection/socket';
import { TeleprompterSectionInterface } from '../../../types/interfaces';
import Avatar from '../../general-components/avatar';

interface UserMap {
	[key: string]: ConnectedUser;
}

function timeSince(timestamp: number): string {
	if (!timestamp) return "";

	var seconds = Math.floor((new Date().valueOf() - timestamp) / 1000);

	var interval = Math.floor(seconds / 31536000);

	if (interval > 1) {
		return interval + " y ago";
	}
	interval = Math.floor(seconds / 2592000);
	if (interval > 1) {
		return interval + " mth ago";
	}
	interval = Math.floor(seconds / 86400);
	if (interval >= 1) {
		return interval + " d ago";
	}
	interval = Math.floor(seconds / 3600);
	if (interval >= 1) {
		return interval + " h ago";
	}
	interval = Math.floor(seconds / 60);
	if (interval >= 1) {
		return interval + " m ago";
	}
	return "Just now"
}

export default function NoteLink(props: any) {
	const {
		note,
		users
	} = props;

	// This is used to parse the note's shared_with property because simple notes (gr_notes) store users a note is shared with
	// as a comma separated string of user ids and teleprompted notes (gr_teleprompters) return them as an array.
	const selectedShare = useMemo(() => {
		if (note.shared_with && typeof note.shared_with === 'string') {
			return note.shared_with.split(",").map((str: String) => Number(str));
		} else if (note.shared_with && !(typeof note.shared_with === 'string')) {
			return note.shared_with;
		} else {
			return [];
		}
	}, [note, users]);


	const sharedUserMap = useMemo(() => {
		const obj: UserMap = {};
		let len = selectedShare.length;

		for (let i = 0; i < len; ++i) {
			// Decoupling migration strategy: include "brandlive_profile" here because pre-decoupled notes could have been shared with
			// "brandlive_profile" IDs before "gr_user" IDs existed.
			let user = users.find((_user: ConnectedUser) => _user.gr_user === selectedShare[i] || _user.brandlive_profile === selectedShare[i]);
			if (user)
				obj[String(selectedShare[i])] = user;
		}

		return obj;
	}, [users, selectedShare]);

	const displayPlusAvatar = useMemo(() => {
		if (selectedShare.length > 7 && selectedShare.length !== 8) {
			return true;
		} else {
			return false;
		}
	}, [selectedShare]);

	return note.title || note.content_text || (note.sections && note.sections.some((section: TeleprompterSectionInterface) => section.section_data.hasContent)) ? (
		<div className='tab-row'>
			<button className="note-link width-full text-white" onClick={props.onClick}>
				<div className="note-meta">
					<span className="margin-right-small truncate-overflow">{note.edited_date ? timeSince(note.edited_date) : timeSince(note.created_date)}</span>
					<label className="font-weight-heavy truncate-overflow width-full text-align-left">{note.title || "Untitled"}</label>
					{note.shared_with ? (
						<div className="presenters">
							{selectedShare.map((id: string, index: number) => {
								if ((index < 7 || selectedShare.length === 8) && !!sharedUserMap[id]) {
									return (
										<div key={id} className="avatar-container">
											<Avatar
												user={sharedUserMap[id]}
												noBorder={true}
												size={'thirtytwo'}
											/>
										</div>
									)
								}
							})}
							{displayPlusAvatar && (
								<div className="avatar-container">
									<div className="avatar-placeholder">
										+{selectedShare.length - 7}
									</div>
								</div>
							)}
						</div>

					) : null}
				</div>
				<Icon name={ICONS.ARROW_RIGHT} size={17} color={COLORS.WHITE} />
			</button>

		</div>
	) : null;
}